<template>
  <div class="lecture-remove">
      스크래치 Lecture Remove
    <!-- 일단 실습방 자체를 위해 하단 비활성화 -->
    <!-- <div class="prctice-header">Scratch Prctice Header</div> -->
    <!-- <div class="prctive-contents"> -->
      <!-- <Scrtc-Lib></Scrtc-Lib> -->
      <!-- <modal-learning-guide v-if="showGuide" @close="showGuide= false" :guideData="guideData"></modal-learning-guide> -->
    <!-- </div> -->
  </div>
</template>

<script>

/** Scratch Library를 해당 View에서만 독립적으로 Import **/
// import * as ScrtcLib from '../../public/scrtc/lib.min'
// import * as ScrtcGui from '../../public/scrtc/gui'
import { APIURL } from '../data/config';
import axios from 'axios'

export default {
  name: 'Lecture Remove',
  /** Scratch Library를 해당 View에서만 독립적으로 Import(하단방식도 정상동작) **/
  mounted() {
    var id = this.$route.params.id;

    const getCookie = this.getCookie('JSESSIONID');

    if(!getCookie){
        alert('잘못된 사용자 정보입니다.');
        window.location.href = "/esof/prdct/lctreListView.do";
        return;
    }

    /*
        강의 삭제시 호출해야 할 것들.
        
    */
    axios.delete(
        APIURL + '/manage/scrtc/cntnts',
        { 
          data: {
            cntnts_sn : id
          },
          headers : {
              'Content-Type': 'application/json',
              'LbCookie': document.cookie
          },
        }
    ).then(function(res){
        if(res.status == 200){
            if(res.data.code == 1000){
                alert('강의를 삭제하였습니다.');
                window.location.href = "/esof/prdct/lctreListView.do";
            }else{
                alert('강의 삭제에 실패하였습니다');
                window.location.href = "/esof/prdct/lctreListView.do";
            }
        }else{
            alert('통신 오류가 발생하였습니다.');
            window.location.href = "/esof/prdct/lctreListView.do";
        }
    });
  },
  methods: {
    getCookie (name) {  /// Retrieve cookie function
      var match = document.cookie.match(new RegExp(name + '=([^;]+)'));
      if (match) return match[1];
      return
    },
  },
}
</script>

<style lang="scss">
  .lecture-remove {
      
  }
</style>

